import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { FormFieldsContainer } from '../../../Form'
import { FormikField } from '../../../Formik'
import { RadioGroup } from '../../../Radio'
import Text from '../../../Text'
import { REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE } from '../RequestEditPipelineModal.constants'
import {
  getRequestEditPipelineModalRadioOptions,
  isRequestEditPipelineModalYesNoOptionValueYes,
} from '../RequestEditPipelineModal.utils'

import * as styles from './RequestEditPipelineModalFields.module.css'

function RequestEditPipelineModalFields() {
  const { t } = useTranslation()
  const { values } = useFormikContext()

  const radioOptions = getRequestEditPipelineModalRadioOptions(t)

  const selectedValue =
    values?.[REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE]

  const isSwitchPipeline =
    isRequestEditPipelineModalYesNoOptionValueYes(selectedValue)

  const notificationsClassName = classNames(styles.notifications, {
    [styles.notificationsDisabled]: !isSwitchPipeline,
  })

  return (
    <FormFieldsContainer className={styles.formFieldsContainer}>
      <FormikField
        Component={RadioGroup}
        Field={Fragment}
        name={REQUEST_EDIT_PIPELINE_MODAL_FIELD_NAME_SWITCH_PIPELINE}
        options={radioOptions}
        title={t('RequestProfile.EditPipelineModalQuestionTextKey')}
      />
      <div className={notificationsClassName}>
        <div className={styles.notificationItem}>
          <Text isSecondary>
            {t('RequestProfile.EditPipelineModalYesDescriptionTextKey')}
          </Text>
        </div>

        <div className={styles.notificationItem}>
          <Text isSecondary>
            {t('RequestProfile.EditPipelineModalYesAttentionTextKey')}
          </Text>
        </div>
      </div>
    </FormFieldsContainer>
  )
}

export default RequestEditPipelineModalFields
